import { UserCog, AlertTriangle, TrendingDown, FileWarning, Layers, BrainCircuit } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { SectionBg } from "./Decor";
import { ScrollReveal } from "@/components/motion/ScrollReveal";
import { ASSETS } from "@/lib/site";
import { useLang } from "@/i18n/LanguageContext";

const ICONS = [UserCog, AlertTriangle, TrendingDown, FileWarning, Layers, BrainCircuit];

export const ProblemSection = () => {
  const { t } = useLang();
  const p = t.problem;
  return (
    <section id="problem" className="relative scroll-mt-24 py-24 lg:py-32 overflow-hidden">
      <SectionBg src={ASSETS.problemBg} />
      <div className="glow-orb animate-glow pointer-events-none" style={{ zIndex: 0, width: 480, height: 360, top: -60, right: "-4%", background: "var(--red)", opacity: 0.12 }} />
      <div className="relative z-10 mx-auto max-w-7xl px-5">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <SectionHeading eyebrow={p.eyebrow} title={p.title} intro={p.intro} testId="problem-heading" />
            <div className="mt-8 glass-card rounded-2xl p-5 flex items-center gap-4" data-testid="problem-stat">
              <div className="font-display text-4xl font-bold text-[var(--red)]">1</div>
              <p className="text-sm text-muted leading-relaxed">{p.statText}</p>
            </div>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4" data-testid="problem-risks">
            {p.risks.map((r, i) => {
              const Icon = ICONS[i];
              return (
                <ScrollReveal key={i} delay={i * 0.06} className="h-full">
                  <div className="glass-card hover-lift rounded-2xl p-5 h-full" data-testid={`problem-risk-${i}`}>
                    <div className="flex items-start gap-4">
                      <span className="grid place-items-center h-10 w-10 shrink-0 rounded-xl border border-[rgba(255,92,108,0.25)] bg-[rgba(255,92,108,0.07)] text-[var(--red)]">
                        <Icon size={18} />
                      </span>
                      <div>
                        <p className="text-[var(--white)] font-medium leading-snug">{r.text}</p>
                        <span className="mt-2 inline-block font-mono text-[10px] uppercase tracking-widest text-[var(--muted-2)]">
                          {r.tag}
                        </span>
                      </div>
                    </div>
                  </div>
                </ScrollReveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
